var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9231 11.5V14.1923H3.07692V11.5H0V17.2692H20V11.5H16.9231ZM19.2308 16.5H0.769231V12.2692H2.30769V14.9615H17.6923V12.2692H19.2308V16.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76751 11.938C9.8426 12.0131 9.94107 12.0507 10.0394 12.0507C10.1378 12.0507 10.2363 12.0131 10.3114 11.938L12.8579 9.39145C13.0081 9.24125 13.0081 8.99779 12.8579 8.8476C12.7077 8.69741 12.4642 8.69741 12.314 8.8476L10.3846 10.7769V0.730774H9.61539V10.6981L7.68597 8.76866C7.53578 8.61847 7.29232 8.61847 7.14212 8.76866C6.99193 8.91885 6.99193 9.16231 7.14212 9.3125L9.76751 11.938ZM10.0665 11.0951L10.0395 11.1221L10.0125 11.0951H10.0665Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.b1c61645df66c1e2ab7fecce8b336533.svg";
export { ForwardRef as ReactComponent };